import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon as FAIcon } from "@fortawesome/react-fontawesome";
import * as icons from "./FontAwesomeLibrary";

library.add(icons);

export const FontAwesomeIcon = FAIcon;
